"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[493],{

/***/ 40493:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ hubspot_on_dark_background_form_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/title.js + 1 modules
var title_title = __webpack_require__(91265);
// EXTERNAL MODULE: ./segments/desktop/core-components/paragraph/paragraph.js + 1 modules
var paragraph = __webpack_require__(75073);
// EXTERNAL MODULE: ./segments/desktop/core-components/hubspot-contact-form/hubspot-contact-form.js + 1 modules
var hubspot_contact_form = __webpack_require__(78160);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
// EXTERNAL MODULE: ./client/services/hubspot-service/contact-form-config.js + 1 modules
var contact_form_config = __webpack_require__(49228);
// EXTERNAL MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/side-by-side-text-and-asset.js
var side_by_side_text_and_asset = __webpack_require__(59526);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
;// CONCATENATED MODULE: ./segments/desktop/form/layouts/hubspot-on-dark-background-form/hubspot-on-dark-background-form-component.scss.js





var TEXT_COLOR = "#d6ccff";
var PHONE_TEXT_COLOR = "#727b9a";
var BORDER_COLOR = "#dcdfec";
var StyledHubspotOnDarkBackgroundFormComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "em7wdo20"
})("display:flex;justify-content:center;align-items:center;margin:auto;color:", colors/* default */.Z[color_consts.BRAND_BLACK_TEXT_COLOR], ";flex-direction:column;.side-by-side-text-and-asset .side-by-side-content{display:flex;justify-content:space-between;gap:80px;.full-paragraph-component-wrapper{height:100%;display:flex;padding:0;.content{display:flex;flex-direction:column;justify-content:space-between;text-align:left;height:100%;.top-part{.title-wrapper .core-title{margin-bottom:48px;font-size:2.75rem;font-weight:600;line-height:48px;}.values-list-wrapper{display:flex;flex-direction:column;gap:20px;.value-item{display:flex;line-height:24px;gap:12px;font-size:1rem;text-align:left;.vi-icon .picture-component{display:flex;height:20px;}}}.seperator-line{width:430px;height:1px;background-color:", BORDER_COLOR, ";margin:32px 0;}}.bottom-part{.customer-quote-wrapper{background-color:", colors/* default */.Z[color_consts.BRAND_LIGHT_COLOR_NAME], ";border-radius:8px;padding:24px 32px;margin-bottom:32px;width:600px;.quote{position:relative;margin:auto 0;display:flex;text-align:left;letter-spacing:-0.5px;line-height:30px;font-size:1.125rem;.quotationMark{position:absolute;top:0;left:-12px;margin-right:8px;}}.costumer-details{display:flex;margin-top:32px;gap:16px;.face-picture{.picture-component{img{width:48px;}}}.name-and-job-description{line-height:25px;display:flex;justify-content:center;flex-direction:column;.name{font-size:0.875rem;font-weight:600;line-height:20px;}.job-description{line-height:20px;font-size:0.875rem;}}}}}}}.image-wrapper{overflow:unset;.form-wrapper{.hubspot-contact-form-wrapper .base-form{width:460px;margin:0;padding:32px;border:1px solid ", BORDER_COLOR, ";box-shadow:0px 5px 16px 0px rgba(0,0,0,0.06);.form-title-wrapper{color:", colors/* default */.Z[color_consts.BRAND_BLACK_TEXT_COLOR], ";text-align:center;.monday-markup-language-component{font-weight:600;font-size:1rem;}}.contact-form-row{margin-bottom:12px;.form-input-wrapper{.required-error{font-size:0.7875rem;}padding:0 5px 0 5px;.generic-form-input-component{.form-input-wrapper{margin-bottom:10px;padding:0;.hp-input{height:46px;border-radius:6px;&.hp-textarea-input{height:80px;}&.hp-phone-input{.react-tel-input{height:46px;input{height:46px;}.flag-dropdown{.country-list{color:", colors/* default */.Z[color_consts.BRAND_BLACK_TEXT_COLOR], ';}}}.react-tel-input::before{content:"*";position:absolute;top:4px;left:44px;color:', PHONE_TEXT_COLOR, ";z-index:", z_index/* TOP_LAYER */.nA, ";font-family:Poppins;}}}.hp-multi-select-input{.react-select__control{min-height:46px;border-radius:6px;text-align:left;.react-select__value-container{min-height:44px;}}}.react-select__menu{z-index:", z_index/* TOP_LAYER */.nA, ";}}}}}.privacy-notice-wrapper .privacy-notice{color:", colors/* default */.Z[color_consts.BRAND_BLACK_TEXT_COLOR], ";margin-top:24px;}}}}}.logos-wrapper{display:flex;flex-direction:column;width:640px;.logos{display:flex;flext-direction:row;width:600px;gap:42px;justify-content:center;.logo-wrapper{.picture-component{img{height:30px;}}}}}@media (max-width:", vp_sizes/* MACBOOK_PRO_MAX_WIDTH */.Wh, "){.side-by-side-text-and-asset .side-by-side-content{gap:32px;.full-paragraph-component-wrapper .content{max-width:540px;.top-part{.title-section .title-wrapper .core-title{font-size:2.25rem;}}.bottom-part{.customer-quote-wrapper{width:500px;}.logos-wrapper .logos{width:500px;gap:36px;.logo-wrapper .picture-component img{height:24px;}}}}}}@media (max-width:1110px) and (min-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){.side-by-side-text-and-asset .side-by-side-content{.full-paragraph-component-wrapper{.content{.bottom-part{.customer-quote-wrapper{width:100%;max-width:600px;box-sizing:border-box;}.logos-wrapper{width:100%;max-width:640px;box-sizing:border-box;.logos{width:100%;max-width:600px;box-sizing:border-box;}}}}}}}@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){.side-by-side-text-and-asset .side-by-side-content{.full-paragraph-component-wrapper{.content{.top-part{.title-section{.title-wrapper .core-title{text-align:left;font-size:1.5rem;line-height:32px;}}}.bottom-part{padding-top:32px;}}}.image-wrapper{.form-wrapper{.hubspot-contact-form-wrapper .base-form{width:560px;.form-title-wrapper{.monday-markup-language-component{font-size:1.5rem;}}.contact-form-row{margin-bottom:0;.form-input-wrapper{margin-bottom:22px;}}}}}}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){&.hubspot-on-dark-background-form-component{padding:0 16px;}.side-by-side-text-and-asset .side-by-side-content{.full-paragraph-component-wrapper{width:100%;padding:0;.content{text-align:center;.top-part{padding:0 16px;.seperator-line{width:100%;}}.bottom-part{.customer-quote-wrapper{width:100%;padding:32px;.quoteText{text-align:center;}.costumer-details{flex-direction:column;align-items:center;gap:8px;.name-and-job-description{align-items:center;}}}.logos-wrapper{width:100%;max-width:100vw;.logos{width:100%;gap:16px;flex-wrap:wrap;justify-content:center;}}}}}.image-wrapper{padding:0 !important;.form-wrapper{.hubspot-contact-form-wrapper .base-form{width:100%;min-width:0;padding:32px;box-shadow:none;.form-title-wrapper{.monday-markup-language-component{font-size:1.5rem;}}}}}}}");

;// CONCATENATED MODULE: ./segments/desktop/form/layouts/hubspot-on-dark-background-form/consts.js
var VI_ICON = "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Contact%20sales%20page/ong/4_checkmark.png";

// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
;// CONCATENATED MODULE: ./segments/desktop/form/layouts/hubspot-on-dark-background-form/hubspot-on-dark-background-form-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}











var HubspotOnDarkBackgroundFormComponent = function(props) {
    var LeftSideContent = props.LeftSideContent, formId = props.formId;
    var ref = LeftSideContent || {}, title = ref.title, textUnderSeparator = ref.textUnderSeparator, valuesList = ref.valuesList, sentenceAboveLogos = ref.sentenceAboveLogos, customerQuote = ref.customerQuote, logos = ref.logos;
    var ref1 = customerQuote || {}, quote = ref1.quote, name = ref1.name, jobDescription = ref1.jobDescription, companyName = ref1.companyName, facePicture = ref1.facePicture;
    var renderLeftSide = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "content",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "top-part",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "title-section",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "title-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(title_title/* default */.Z, {
                                        title: title,
                                        titleSize: sizes.LG
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "values-list-wrapper",
                                    children: valuesList === null || valuesList === void 0 ? void 0 : valuesList.map(function(valueItem, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "value-item",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "vi-icon",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                                        src: VI_ICON
                                                    })
                                                }),
                                                valueItem.value
                                            ]
                                        }, index);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "seperator-line"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-under-separator",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(paragraph/* default */.Z, {
                                body: textUnderSeparator,
                                textSize: sizes.MS
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "bottom-part",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "customer-quote-wrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("blockquote", {
                                    className: "quote",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "quoteText",
                                        children: "”".concat(quote, "”")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "costumer-details",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "face-picture",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                                src: facePicture
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "name-and-job-description",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "name",
                                                    children: name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "job-description",
                                                    children: "".concat(jobDescription, " | ").concat(companyName)
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "logos-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "logos",
                                children: logos === null || logos === void 0 ? void 0 : logos.map(function(logo, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "logo-wrapper",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, _object_spread({}, logo))
                                    }, index);
                                })
                            })
                        })
                    ]
                })
            ]
        });
    };
    var getFormId = function() {
        return formId || contact_form_config/* CONTACT_SALES_HUBSPOT_FORM_ID */.PD;
    };
    var renderForm = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "form-wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(hubspot_contact_form/* default */.Z, _object_spread({
                isV2: true,
                formId: getFormId()
            }, props))
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHubspotOnDarkBackgroundFormComponent, {
        className: "hubspot-on-dark-background-form-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(side_by_side_text_and_asset/* default */.Z, {
            replaceTextComponent: renderLeftSide,
            replaceAssetComponent: renderForm,
            mobileSwapTextAndAssetPosition: true
        })
    });
};
/* harmony default export */ var hubspot_on_dark_background_form_component = (/*#__PURE__*/(0,react.memo)(HubspotOnDarkBackgroundFormComponent));


/***/ })

}]);